<div ngbDropdown placement="bottom-right" #columnsDropdown="ngbDropdown">
    <button class="btn btn-info" id="columnMenu" ngbDropdownToggle (click)="dropdownToggle()"><i class="fa fa-table-columns"></i><span class="ms-1">{{ 'columns' | translate }}</span></button>
	<div ngbDropdownMenu aria-labelledby="columnMenu" class="column-menu p-2">
		<form #f='ngForm'>
			<div class="inner-addon right-addon mb-2">
				<i class="fa fa-search"></i>
				<input type="text" class="form-control" placeholder="{{ 'search' | translate }}" (keyup)="onSearchColumn($event)" />
			</div>
			<div class="columns-container">
				<div *ngIf="this.checkAreColumnsVisible(this.staticColumns)">
					<div class="form-check" *ngFor="let column of this.staticColumns">
						<div *ngIf="column.visible">
							<input class="form-check-input" type="checkbox" [(ngModel)]="column.selected"
								   id="check-static-{{column.id}}" name="'check-static-{{column.id}}'">
							<label class="form-check-label" for="check-static-{{column.id}}"
								   jhiTranslate="search-germplasm.column.{{column.colLabel}}">
							</label>
						</div>
					</div>
				</div>
			</div>
			<hr class="mt-3 mb-0" />
			<div class="text-center"><br>
				<button type="submit" class="btn btn-primary btn-sm" (click)="apply()"
					data-test="displayColumnApplyButton" jhiTranslate="apply">Apply</button>
			</div>
		</form>
	</div>
</div>
